import { supportedlanguages } from '@common/Utility/constants';

export const getLangCodeFromUrl = () => {
  const { pathname } = window.location;
  const segment = pathname?.split('/')?.[1];
  const langCode = segment?.split('-')?.[1];
  return langCode || supportedlanguages.EN;
};

export const getRegionCodeFromUrl = (isFromAnalytics = false) => {
  const { pathname } = window.location;
  const segment = pathname?.split('/')?.[1];
  const regionCode = segment?.split('-')?.[0];
  if(isFromAnalytics)
    return regionCode?.toUpperCase() || "AE";
  return regionCode?.toUpperCase() === "UAE" ? "AE" : (regionCode?.toUpperCase() || "AE");
}